/* eslint-disable array-callback-return */
import React, { Component } from 'react';
import Inputlayer from './input';
import Selectlayer from './select';
import Button from './button';
// import EditorChartLayer from './editor_chart';
import postService from '../../services/httpService';
import { Select, Modal, Input, InputNumber } from 'antd';
import RadioButton from './radio_button';
import Checkboxlayer from './check_box';
import UploadFile from './upload';
import Datepicker from './Datepicker';
const { Option } = Select;

class Formcomponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            error: null,
            feilds_data: [],
        };
        this.feildChange = this.feildChange.bind(this);
        this.deleteChange = this.deleteChange.bind(this);
        // this.addattachments = this.addattachments.bind(this);
    }
    componentDidMount() {
        let { feilds } = this.props;
        this.setState({ 'feilds_data': feilds })
    }

    componentDidUpdate(prevProps, prevState) {
        let { feilds_data } = prevState;
        let { feilds } = this.props;
        if (feilds.length !== feilds_data.length) {
            this.setState({ 'feilds_data': feilds })
        }
    }

    componentWillUnmount() {
        this.setState({
            date: new Date(),
            error: null,
            feilds_data: [],
        })
    }

    feildChange(data) {
        console.log('datadata', data)
        let { feilds, current_tab } = this.props;
        let isDisable = false;
        console.log(this.props.form_openn);
        if (this.props.form_openn === "cash") {
        feilds.map((feild, key) => {
            if (feild['name'] === data['name']) {
                feilds[key] = data;

                if (data['name'] === 'chapter_title' && data['value'] && data['value'] !== '') {
                    this.props.buttonClick(this.state.feilds_data, { 'type': 'chapter_tite' }, current_tab ? current_tab : null)
                    if (feild['name'] === 'long_description') {
                        feilds['disable'] = false;
                    }
                }
                if (data['name'] === 'estimated_admission_date') {
                    this.props.buttonClick(this.state.feilds_data, { 'type': 'estimated_admission_date' }, current_tab ? current_tab : null)
                }
                if (data['name'] === 'reject_reason' && data['value'] && data['value'] !== '') {
                    this.props.buttonClick(this.state.feilds_data, { 'type': 'reject_reason' }, current_tab ? current_tab : null)
                }
                if (data['name'] === 'role_name' && data['value'] && data['value'] !== '') {
                    this.props.buttonClick(this.state.feilds_data, { 'type': 'role_name' }, current_tab ? current_tab : null)
                }
                if (data['name'] === 'subreports' && data['value'] && data['value'] !== '') {
                    this.props.buttonClick(this.state.feilds_data, { 'type': 'sub_reports' }, current_tab ? current_tab : null)
                }
                if (data['name'] === 'access_type' && data['value'] && data['value'] !== '') {
                    this.props.buttonClick(this.state.feilds_data, { 'type': 'accesstype' }, current_tab ? current_tab : null)
                }
                if (data['name'] === 'care_management' && data['value'] && data['value'] !== '') {
                    this.props.buttonClick(this.state.feilds_data, { 'type': 'care_management' }, current_tab ? current_tab : null)
                }
                if (data['name'] === 'diagnosis') {
                    this.props.buttonClick(this.state.feilds_data, { 'type': 'diagnosis' }, current_tab ? current_tab : null)
                }
                if (data['name'] === 'estimate_type') {
                    this.props.buttonClick(this.state.feilds_data, { 'type': 'estimate_type' }, current_tab ? current_tab : null)
                }
                if (data['name'] === 'date_of_surgery') {
                    this.props.buttonClick(this.state.feilds_data, { 'type': 'date_of_surgery' }, current_tab ? current_tab : null)
                }
                if (data['name'] === 'package_name') {
                    this.props.buttonClick(this.state.feilds_data, { 'type': 'package_name' }, current_tab ? current_tab : null)
                }
                if (data['name'] === 'surgery_procedure_name' && data['value'] && data['value'] !== '') {
                    this.props.buttonClick(this.state.feilds_data, { 'type': 'surgery_procedure_name' }, current_tab ? current_tab : null)
                }
                if (data['name'] === 'room_stay') {
                    this.props.buttonClick(this.state.feilds_data, { 'type': 'room_stay' }, current_tab ? current_tab : null)
                }
                if (data['name'] === 'icu_stay') {
                    this.props.buttonClick(this.state.feilds_data, { 'type': 'icu_stay' }, current_tab ? current_tab : null)
                }
                if (data['name'] === 'room_opted' && data['value'] && data['value'] !== '') {
                    this.props.buttonClick(this.state.feilds_data, { 'type': 'room_opted' }, current_tab ? current_tab : null)
                }
                if (data['name'] === 'icu_opted' && data['value'] && data['value'] !== '') {
                    this.props.buttonClick(this.state.feilds_data, { 'type': 'icu_opted' }, current_tab ? current_tab : null)
                }
                if (data['name'] === 'room_upgrade' ) {
                    this.props.buttonClick(this.state.feilds_data, { 'type': 'room_upgrade' }, current_tab ? current_tab : null)
                }
                if (data['name'] === 'name_of_the_fc') {
                    this.props.buttonClick(this.state.feilds_data, { 'type': 'name_of_the_fc' }, current_tab ? current_tab : null)
                }
                if (data['name'] === 'attendant_name') {
                    this.props.buttonClick(this.state.feilds_data, { 'type': 'attendant_name' }, current_tab ? current_tab : null)
                }
                if (data['name'] === 'relation') {
                    this.props.buttonClick(this.state.feilds_data, { 'type': 'relation' }, current_tab ? current_tab : null)
                }
                if (data['name'] === 'remarks') {
                    this.props.buttonClick(this.state.feilds_data, { 'type': 'remarks' }, current_tab ? current_tab : null)
                }
                
               
            }
        });
    }

        if (this.props.form_openn === 'insurance') {
            feilds.map((feild, key) => {
                if (feild['name'] === data['name']) {
                    feilds[key] = data;
                    if (data['name'] === 'estimated_admission_date') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'estimated_admission_date' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'type_of_patient') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'type_of_patient' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'policy_no') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'policy_no' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'reason_if_denied') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'reason_if_denied' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'employer_name_company') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'employer_name_company' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'date_of_surgery') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'date_of_surgery' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'care_management') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'care_management' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'estimate_type') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'estimate_type' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'room_stay' &&  data['value'] !== '') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'room_stay' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'icu_stay' &&  data['value'] !== '') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'icu_stay' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'room_opted' && data['value'] && data['value'] !== '') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'room_opted' }, current_tab ? current_tab : null)
                    }   
                    if (data['name'] === 'room_upgrade' && data['value'] && data['value'] !== '') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'room_upgrade' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'type_insurance') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'type_insurance' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'insurance_status') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'insurance_status' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'ins_surgery_procedure_name') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'ins_surgery_procedure_name' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'package_name') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'package_name' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'ins_package_name') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'ins_package_name' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'ins_ailment_capping') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'ins_ailment_capping' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'final_approval_amount') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'final_approval_amount' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'discount') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'discount' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'basic_sum_insured') {
                        // this.props.buttonClick(this.state.feilds_data, { 'type': 'basic_sum_insured' }, current_tab ? current_tab : null)
                        this.props.buttonClick(feilds, { 'type': 'basic_sum_insured' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'top_up_amount') {
                        this.props.buttonClick(feilds, { 'type': 'top_up_amount' }, current_tab ? current_tab : null)
                        // this.props.buttonClick(this.state.feilds_data, { 'type': 'top_up_amount' }, current_tab ? current_tab : null)

                    }
                    if (data['name'] === 'balance_sum_insured') {
                        this.props.buttonClick(feilds, { 'type': 'balance_sum_insured' }, current_tab ? current_tab : null)
                        // this.props.buttonClick(this.state.feilds_data, { 'type': 'balance_sum_insured' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'remarks') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'remarks' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'attendant_name') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'attendant_name' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'relation') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'relation' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'ins_room_upgrade_reason') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'ins_room_upgrade_reason' }, current_tab ? current_tab : null)
                    }
                   
                }
                if (feild.name === 'ins_room_eligible' && feild.type && feild.type === 'group') {
                        let group = feild['data'];
                        group.map((sub_feild, sub_key) => {
                        if (sub_feild.name === data['name']){
                            if (data['name'] === 'ins_room_eligible_percent') {
                                // this.props.buttonClick(this.state.feilds_data, { 'type': 'ins_room_eligible_percent' }, current_tab ? current_tab : null)
                                this.props.buttonClick(feilds, { 'type': 'ins_room_eligible_percent' }, current_tab ? current_tab : null)
                            }
                        }
                    });
                }
                if (feild.name === 'ins_icu_eligible' && feild.type && feild.type === 'group') {
                    let group = feild['data'];
                    group.map((sub_feild, sub_key) => {
                    if (sub_feild.name === data['name']){
                        if (data['name'] === 'ins_icu_percent') {
                            this.props.buttonClick(feilds, { 'type': 'ins_icu_percent' }, current_tab ? current_tab : null)
                            // this.props.buttonClick(this.state.feilds_data, { 'type': 'ins_icu_percent' }, current_tab ? current_tab : null)
                        }
                    }
                });
            }
                   
                    if (data['name'] === 'co_pay') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'co_pay' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'signature_of_patient_attendant') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'signature_of_patient_attendant' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'tpa_name') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'tpa_name' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'insurance_company_name') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'insurance_company_name' }, current_tab ? current_tab : null)
                    }
                    
                    if (data['name'] === 'ins_copay_percent') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'ins_copay_percent' }, current_tab ? current_tab : null)
                    }
                    // if (data['name'] === 'ins_select_difference') {
                    //     this.props.buttonClick(this.state.feilds_data, { 'type': 'ins_select_difference' }, current_tab ? current_tab : null)
                    // }
                    if (data['name'] === 'ins_room_eligible_ward_names') {
                        // this.props.buttonClick(this.state.feilds_data, { 'type': 'ins_room_eligible_ward_names' }, current_tab ? current_tab : null)
                        this.props.buttonClick(feilds, { 'type': 'ins_room_eligible_ward_names' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'ins_upgrade_room_names') {
                        // this.props.buttonClick(this.state.feilds_data, { 'type': 'ins_upgrade_room_names' }, current_tab ? current_tab : null)
                        this.props.buttonClick(feilds, { 'type': 'ins_upgrade_room_names' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'ins_icu_type') {
                        // this.props.buttonClick(this.state.feilds_data, { 'type': 'ins_icu_type' }, current_tab ? current_tab : null)
                        this.props.buttonClick(feilds, { 'type': 'ins_icu_type' }, current_tab ? current_tab : null)

                    }
                   
                    

            });
        }

        if (this.props.form_openn === 'corporate') {
            feilds.map((feild, key) => {
                if (feild['name'] === data['name']) {
                    feilds[key] = data;
    
                    if (data['name'] === 'chapter_title' && data['value'] && data['value'] !== '') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'chapter_tite' }, current_tab ? current_tab : null)
                        if (feild['name'] === 'long_description') {
                            feilds['disable'] = false;
                        }
                    }
                    if (data['name'] === 'reject_reason' && data['value'] && data['value'] !== '') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'reject_reason' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'role_name' && data['value'] && data['value'] !== '') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'role_name' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'subreports' && data['value'] && data['value'] !== '') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'sub_reports' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'access_type' && data['value'] && data['value'] !== '') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'accesstype' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'care_management' && data['value'] && data['value'] !== '') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'care_management' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'diagnosis') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'diagnosis' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'estimate_type') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'estimate_type' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'package_name') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'package_name' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'surgery_procedure_name' && data['value'] && data['value'] !== '') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'surgery_procedure_name' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'room_stay') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'room_stay' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'icu_stay') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'icu_stay' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'room_opted' && data['value'] && data['value'] !== '') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'room_opted' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'icu_opted' && data['value'] && data['value'] !== '') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'icu_opted' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'room_upgrade' && data['value'] && data['value'] !== '') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'room_upgrade' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'name_of_the_fc') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'name_of_the_fc' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'attendant_name') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'attendant_name' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'relation') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'relation' }, current_tab ? current_tab : null)
                    }
                    if (data['name'] === 'room_eligibility') {
                        this.props.buttonClick(this.state.feilds_data, { 'type': 'room_eligibility' }, current_tab ? current_tab : null)
                    }
                    
                   
                }
            });

           
        }


        console.log(feilds);
        this.setState({ 'feilds_data': feilds })
    }


    buttonClick(button) {
        let { current_tab } = this.props;
        let feilds = this.state.feilds_data
        console.log(feilds);
        let errors = [];
        if (button.type && button.type !== 'cancel') {
            console.log(feilds);
            feilds.map((feild, key) => {
                if (feild['element'] !== button && feild['rules'] && Array.isArray(feild['rules'])) {

                    feild['rules'].map((rule, ruleKey) => {
                        if (rule['rule'] && rule['rule'](feild['value']) === true) {
                            errors.push(true);
                            feilds[key]['error'] = null;
                        }
                        if (rule['rule'] && rule['rule'](feild['value']) === false) {
                            errors.push(false);
                            feilds[key]['error'] = rule['message'];
                        }
                    })


                }

            })
            if (!errors.includes(false)) {
                console.log(feilds);
                this.props.buttonClick(this.state.feilds_data, button, current_tab ? current_tab : null)
            } else {
                console.log(errors.includes(false));
                this.setState({ 'feilds_data': feilds })
            }
        }

        if (button.type && button.type === 'cancel') {
            feilds.map((feild, key) => {
                feilds[key]['error'] = null;
                feilds[key]['value'] = null;
            })
            this.setState({ 'feilds_data': feilds }, () => {
                this.props.buttonClick(this.state.feilds_data, button, current_tab ? current_tab : null)
            })
        }
    }

    // addattachments(evt) {
    //     console.log(evt);
    //     let { feilds, current_tab } = this.props;
    //     feilds.map((data, key) => {
    //         if (data['name'] === evt.target.name) {
    //             feilds[key]['value'] = evt.target.files;
    //         }
    //     })
    //     this.setState((state) => ({ 'feilds_data': feilds }));
    //     console.log(this.state.feilds_data);
    // }

    deleteChange(data) {
        let feilds = this.state.feilds_data
        let { current_tab } = this.props;

        feilds.map((feild, key) => {
            if (feild['element'] !== 'button' && feild['value'] && feild['value'] !== '' && (feild['name'] === "long_description" || feild['name'] === 'methodology_description' || feild['name'] === 'preview_analysis_description')) {
                var regexeq = new RegExp(`<section class="product" data-id="${data.id}"></section>`, "g");
                feilds[key]['value'] = feild['value'].replace(regexeq, '');
            }
        })
        this.setState({ 'feilds_data': feilds }, () => {
            this.props.buttonClick(this.state.feilds_data, { 'type': 'viz_delete' }, current_tab ? current_tab : null)
        })
    }


    renderBody(data, key) {
        let { current_tab } = this.props;
        if (data.visible && data.element === 'input') {
            return <Inputlayer {...this.props} {...this.state} feild_data={data} key={key} inputChange={this.feildChange} />
        }
        if (data.visible && data.element === 'select') {
            return <Selectlayer {...this.props} {...this.state} feild_data={data} key={key} inputChange={this.feildChange} />
        }
        // if (data.element === 'editor_chart') {
        //     return <EditorChartLayer {...this.props} {...this.state} feild_data={data} key={key} inputChange={this.feildChange} deleteChange={this.deleteChange} />
        // }
        if (data.visible && data.element === 'radio') {
            return <RadioButton {...this.props} {...this.state} feild_data={data} key={key} inputChange={this.feildChange} />
        }
        if (data.visible && data.element === 'checkbox') {
            console.log('if 2');
            return <Checkboxlayer {...this.props} {...this.state} feild_data={data} key={key} inputChange={this.feildChange} />
        }
        if (data.visible && data.element === 'datepicker') {
            return <Datepicker {...this.props} {...this.state} feild_data={data} key={key} inputChange={this.feildChange} />
        }
        if (data.visible && data.element === 'upload') {
            // return <input type="file" className="form-control" name="attachments" multiple="multiple" accept="image/jpg, image/jpeg, image/png, application/pdf" onChange={this.addattachments} />
            return <UploadFile {...this.props} {...this.state} feild_data={data} key={key} inputChange={this.feildChange} />
        }
        if (data.visible && data.element === 'button') {
            return <Button {...this.props} {...this.state} feild_data={data} key={key} buttonClick={this.buttonClick.bind(this)} />
        }
        if (data.visible && data.element === 'input2') {
            return (
                <div
                    className={`${data.className
                        ? data.className + ' align-self-end'
                        : 'col'} mt-3 ${data.name}`}
                    key={key}>
                    <p className="data-label w-100 mb-1 pt-2">{data.title}</p>
                    <Input.Group compact>
                        {data['data'].map((subFeild, subkey) => {
                            if (subFeild.element === 'input' && subFeild.visible) {
                                return <Inputlayer {...this.props} {...this.state} feild_data={subFeild} key={subkey} inputChange={this.feildChange} />
                            }
                        })
                        }
                    </Input.Group>
                    { data.errors && data.errors.map((error, eKey) => {
                                    return (<small key={eKey} className="form-text text-danger" id={'errorm'+data.name}>{error.message}</small>);
                                })}
                </div>

            )
        }
        if (data.visible && data.element === 'select3') {
            return (
                <div
                    className={`${data.className
                        ? data.className + ' align-self-end'
                        : 'col'} mt-3 ${data.name}`}
                    key={key}>
                    <p className="data-label w-100 mb-1 pt-2">{data.title}</p>
                    <Input.Group compact>
                        {data['data'].map((subFeild, subkey) => {
                            if (subFeild.element === 'select2' && subFeild.visible) {
                                return <Selectlayer {...this.props} {...this.state} feild_data={subFeild} key={subkey} inputChange={this.feildChange} />
                            }
                            if (subFeild.element === 'input' && subFeild.visible) {
                                return <Inputlayer {...this.props} {...this.state} feild_data={subFeild} key={subkey} inputChange={this.feildChange} />
                            }
                        })
                        }
                    </Input.Group>
                    { data.errors && data.errors.map((error, eKey) => {
                                    return (<small key={eKey} className="form-text text-danger" id={'errorm'+data.name}>{error.message}</small>);
                                })}
                </div>

            )
        }
    }
    render() {
        let { feilds } = this.props;
        return (
            <React.Fragment>
                <div className="row">
                    {feilds.map((data, key) => {
                        if (data.element !== 'button') {
                            return this.renderBody(data, key);
                        }
                    })}
                </div>
                <div className="row w-100">
                    {feilds.map((data, key) => {
                        if (data.element === 'button') {
                            return this.renderBody(data, key);
                        }
                    })}
                </div>
            </React.Fragment>
        );
    }
}

export default Formcomponent;
